// src/helpers/phone.js
import { doc, getDoc } from "firebase/firestore";

export async function getLockedUserPhone(db, uid) {
    if (!uid) return { phone: "", phoneCountry: "" };
    const snap = await getDoc(doc(db, "users", uid));
    if (!snap.exists()) return { phone: "", phoneCountry: "" };
    const d = snap.data();
    return { phone: d.phone || "", phoneCountry: d.phoneCountry || "" };
}
// src/utils/phone.js
// ⬇️ append these exports (or create the file if you don't have one)

export const DIAL_BY_COUNTRY_CODE = {
    LK: "+94",
    IN: "+91",
    US: "+1",
    GB: "+44",
    AE: "+971",
    SG: "+65",
    AU: "+61",
};

export function countryToDial(countryOrCode = "") {
    const s = String(countryOrCode || "").trim().toUpperCase();

    if (DIAL_BY_COUNTRY_CODE[s]) return DIAL_BY_COUNTRY_CODE[s];

    if (/SRI\s*LANKA|^LK$/.test(s)) return "+94";
    if (/INDIA|^IN$/.test(s)) return "+91";
    if (/UNITED\s*STATES|^US$|^USA$/.test(s)) return "+1";
    if (/UNITED\s*KINGDOM|^GB$|^UK$/.test(s)) return "+44";
    if (/UNITED\s*ARAB|^AE$|^UAE$/.test(s)) return "+971";
    if (/SINGAPORE|^SG$/.test(s)) return "+65";
    if (/AUSTRALIA|^AU$/.test(s)) return "+61";

    // sensible default for your project
    return "+94";
}

export const digitsOnly = (s = "") => (s || "").replace(/\D/g, "");

export function toE164(input = "", defaultDial = "+94") {
    const raw = String(input || "").trim();
    if (!raw) return "";
    if (raw.startsWith("+")) return raw.replace(/\s+/g, "");
    const d = digitsOnly(raw);
    if (!d) return "";
    return `${defaultDial}${d}`;
}

export function fmtE164(e = "") {
    // simple readable spacing: +94 712 345 678 (best effort)
    if (!e || !e.startsWith("+")) return e || "—";
    return e.replace(/(?<=^\+\d{1,3})(\d{3})(\d{3})(\d+)/, " $1 $2 $3");
}
